export {
  reducer as tagListReducer,
  selectors as tagListSelectors,
  actions as tagListActions
} from './tagListSlice'

export type { Screens, TagListState } from './tagListSlice'
